import Axios from "../Utils/Interceptors";

class AuthService {
  constructor() {
    this.token = null;
    this.setupInterceptors();
  }

  async login(url, email, password, rememberLogin) {
    const response = await Axios.post(url, {
      Email: email,
      UserName: email,
      Password: password,
      rememberLogin: rememberLogin,
      returnUrl: "",
      sesionCookie: true,
    });

    return response;
  }

  setupInterceptors() {
    Axios.interceptors.request.use(
      (config) => {
        if (this.token) {
          config.headers.Authorization = `Bearer ${this.token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}

export default AuthService;
